module.exports = __webpack_public_path__ + "img/Toyota-2019-Camry-2.46cf3f58.png";